import React from 'react'

const Header = () => {
    return (
        <div className="header">
            <h1>$pend</h1>
        </div>
    )
}

export default Header;